export const SinFactura=[
    {
        Header: "No. de Guía",
        accessor: "Guia"
      },
      {
        Header: "Estado",
        accessor: "estado"
      },
      
      {
        Header:"Imagenes",
        accessor:"imagen1",
      },
      {
        Header: "Descripcion Producto",
        accessor: "producto"
      },{
        Header: "Tracking",
        accessor: "tracking"
      },
      {
        Header: "Valor FOB (USD)",
        accessor: "fob"
      },
      {
        Header: "Peso Efectivo (kgs)",
        accessor: "peso"
      },
      {
        Header: "Subir Factura",
        accessor: "url"
      }
]

export const SinFacturaInicial={
    Guia:"-",
    url:"-",
    producto:"-",
    tracking:"-",
    fob:"-",
    peso:"-"
  }